import WisetackApplication from './WisetackApplication'

export * from './WisetackApplication'
export default WisetackApplication
